require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./acupuncture-treats.json") })
        }
      }, "path---acupuncture-treats");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---acupuncture-treats!./.cache/json/acupuncture-treats.json
// module id = 339
// module chunks = 231608221292675